var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('b-tab',{staticClass:"px-3 pt-5",attrs:{"title":_vm.$t('dataSets.preview')}},[_c('Preview')],1),_c('b-tab',{staticClass:"p-3 pt-5",attrs:{"title":_vm.$t('dataSets.parameters')}},[_c('Parameters')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }